<!-- eslint-disable vue/multi-word-component-names -->
<template>
	<b-button
		v-if="!variation.available"
		class="text-uppercase"
		:size="options.size"
		variant="outline-danger"
		block
		disabled
	>
		{{ $t('sold out') }}
	</b-button>
	<b-input-group v-else-if="isSelectedStoreActive && cartItemQuantity">
		<b-input-group-prepend>
			<b-button
				:size="options.size"
				variant="primary"
				:class="{
					'px-3':$nuxt.$route.name !=='checkout'
				}"
				@click.stop="minusClick(variation.unit_measure_type === 'weight' && merchant.settings.general.quantity_increment_value ? cartItemQuantity - +merchant.settings.general.quantity_increment_value : cartItemQuantity - 1)"
			>
				<b-icon-dash height="18" />
			</b-button>
		</b-input-group-prepend>
		<b-form-input
			:value="cartItemQuantity"
			:size="options.size"
			class="text-center p-0"
			readonly
			@click.stop
		/>
		<b-input-group-append>
			<b-button
				:size="options.size"
				variant="primary"
				:disabled="cartItemQuantity >= (variation.track_inventory ? Math.floor(variation.stock) : 100)"
				:class="{
					'px-3':$nuxt.$route.name !=='checkout'
				}"
				@click.stop="plusClick(variation.unit_measure_type === 'weight' && merchant.settings.general.quantity_increment_value ? cartItemQuantity + +merchant.settings.general.quantity_increment_value : cartItemQuantity + 1)"
			>
				<b-icon-plus height="18" />
			</b-button>
		</b-input-group-append>
	</b-input-group>
	<b-button
		v-else-if="isSelectedStoreActive"
		class="text-uppercase"
		:size="options.size"
		variant="primary"
		block
		@click.stop="plusClick(variation.unit_measure_type === 'weight' && merchant.settings.general.quantity_increment_value ? +merchant.settings.general.quantity_increment_value : 1)"
	>
		<b-icon-cart-plus class="mr-1" />
		{{ $t('add to cart') }}
	</b-button>
</template>

<script>
	export default {
		props: {
			item: {
				type: Object,
				required: true
			},
			options: {
				type: Object,
				default: () => ({
					size: 'sm'
				})
			}
		},
		computed: {
			merchant () {
				return this.$store.state.merchant
			},
			selectedStore: {
				get () {
					return this.$store.state.selectedStore
				},
				set (store) {
					this.$store.commit('setSelectedStore', store)
				}
			},
			isSelectedStoreActive () {
				if (this.$route.name === 'checkout') {
					return this.cart.store ? this.cart.store.available : false
				} else {
					return this.selectedStore ? this.selectedStore.available : false
				}
			},
			cart: {
				get () {
					return this.$store.state.cart
				},
				set (value) {
					this.$store.commit('setState', {
						key: 'cart',
						value
					})
				}
			},
			variation () {
				return this.item.variations[this.item.variation_index]
			},
			cartItemQuantity () {
				return this.$route.name === 'checkout'
					? this.variation.quantity
					: this.cart.items.reduce((quantity, item) => {
						const variation = item.variations[item.variation_index]

						if (variation.id === this.variation.id && this.selectedStore.id === this.cart.store.id) {
							quantity += variation.quantity
						}

						return quantity
					}, 0)
			},
			quantityIncrementValue () {
				return this.item.variations[this.item.variation_index].unit_measure_type === 'weight' && this.merchant.settings.general.quantity_increment_value ? +this.merchant.settings.general.quantity_increment_value : 1
			},
			selectedItem: {
				get () {
					return this.$store.state.selectedItem
				},
				set (value) {
					this.$store.commit('setState', { key: 'selectedItem', value })
				}
			}
		},
		methods: {
			plusClick (quantity) {
				const itemTotalQuantity = this.cart.items.reduce((sum, item) => {
					const cartItemVariation = item.variations[item.variation_index]

					if (cartItemVariation.id === this.variation.id) {
						sum += cartItemVariation.quantity
					}

					return sum
				}, 0) + this.quantityIncrementValue

				if (itemTotalQuantity <= (this.variation.track_inventory ? Math.floor(this.variation.stock) : 100)) {
					if (this.$route.name !== 'checkout' && this.variation.modifiers.length) {
						this.selectedItem = this.item
						this.$root.$emit('show-modifiers')
					} else {
						this.$root.$emit('add-item', {
							item: this.item,
							quantity
						})
					}
				}
			},
			minusClick (quantity) {
				if (this.$route.name !== 'checkout' && this.cart.items.filter((i) => {
					return i.variations[i.variation_index].id === this.item.variations[this.item.variation_index].id
				}).length > 1) {
					this.showToast(this.$options.filters.capitalize(this.$t('toastMessage.multipleCustomizations')), {
						title: `${this.$t('oops')}!`,
						variant: 'danger'
					})
				} else {
					this.$root.$emit('add-item', {
						item: this.item,
						quantity
					})
				}
			}
		}
	}
</script>
